"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcModalConstants = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var BcModalConstants = (function () {
    function BcModalConstants() {
    }
    BcModalConstants.MODAL = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-modal");
    BcModalConstants.MODAL_ACTIVE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-modal-active");
    BcModalConstants.BC_MODAL_CLOSE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-modal-close-button");
    BcModalConstants.BC_MODAL_BUTTON_CONTAINER = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-modal-button-container");
    BcModalConstants.BC_MODAL_TITLE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-modal-title");
    BcModalConstants.BC_MODAL_TITLE_LABEL = "modal-title-label";
    BcModalConstants.BC_MODAL_CONTENT = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-modal-content");
    BcModalConstants.BC_MODAL_OVERLAY = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-modal-overlay");
    BcModalConstants.BC_MODAL_DROPDOWN = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-dropdown-toggle");
    BcModalConstants.BC_MODAL_DROPDOWN_ACTIVE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-dropdown-toggle-active");
    BcModalConstants.BC_MODAL_INPUT_DATE_RANGE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-input-date-range ").concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-dropdown-active");
    BcModalConstants.OPEN_STATE_MODAL = 1;
    BcModalConstants.CLOSE_STATE_MODAL = 0;
    BcModalConstants.MAIN_TASK = 1;
    BcModalConstants.SECONDARY_TASK = 0;
    BcModalConstants.BC_MODAL_CONTAINER = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-modal-container");
    BcModalConstants.MODAL_MAX_HEIGHT_PERCENTAGE = 96;
    BcModalConstants.ONE_HUNDRED_PERCENT = 100;
    BcModalConstants.HEIGHT_DOUBLE_BUTTONS = 220;
    BcModalConstants.HEIGHT_SIMPLE_BUTTONS = 240;
    BcModalConstants.WINDOW_750 = 750;
    BcModalConstants.BC_MODAL_N991 = 991;
    BcModalConstants.WINDOW_CAL_3 = 0.3;
    BcModalConstants.MAX_HEIGHT_ATTRIBUTE = 'max-height';
    BcModalConstants.OVERFLOW_VALIDATE = 'validateOverflow';
    BcModalConstants.BC_MODAL_CLASS = '.bc-modal-container';
    BcModalConstants.BC_BUTTON_CLOSED = '.bc-modal-close-button';
    BcModalConstants.ID_CLOSE_BUTTON = 'closeButton';
    BcModalConstants.ID_CLOSE_OUTSIDE = 'closeOutside';
    BcModalConstants.ID_CLOSE_ESC = 'closeESC';
    BcModalConstants.BC_TOOLTIP_CONTAINER_SELECTOR = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-tooltip-container");
    BcModalConstants.BC_TOOLTIP_CLOSE_ANIMATION = "fade-out-opacity 100ms forwards";
    return BcModalConstants;
}());
exports.BcModalConstants = BcModalConstants;
